/**
 * Patient Layout
 * Modern layout with collapsible sidebar and clean header
 */

import React from 'react';
import { Box, Toolbar } from '@mui/material';
import Sidebar, { DRAWER_WIDTH_EXPANDED, DRAWER_WIDTH_COLLAPSED } from '../components/Layout/Sidebar';
import Header from '../components/Layout/Header';
import useSidebar from '../hooks/useSidebar';

const PatientLayout = ({ children }) => {
  const {
    isCollapsed,
    mobileOpen,
    toggleCollapse,
    toggleMobile,
    closeMobile,
  } = useSidebar();

  const sidebarWidth = isCollapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH_EXPANDED;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      {/* Header */}
      <Header
        onMenuClick={toggleMobile}
        isCollapsed={isCollapsed}
        basePath="/Patient"
      />

      {/* Sidebar */}
      <Sidebar
        basePath="/Patient"
        isCollapsed={isCollapsed}
        mobileOpen={mobileOpen}
        onToggleCollapse={toggleCollapse}
        onCloseMobile={closeMobile}
      />

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, sm: 3 },
          width: { xs: '100%', lg: `calc(100% - ${sidebarWidth}px)` },
          maxWidth: '100%',
          overflowX: 'hidden',
          transition: 'all 200ms ease',
          bgcolor: 'background.default',
        }}
      >
        {/* Spacer for fixed header */}
        <Toolbar sx={{ mb: { xs: 2, sm: 3 } }} className="main-toolbar" />
        {children}
      </Box>
    </Box>
  );
};

export default PatientLayout;
